import http from '@/utils/http';
const base_path = '/v2/tool/site';

/**
 * 获取落地页列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getSiteListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 落地页选择器接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getSiteSelectorApi = (params) => {
  return http.get({
    url: `${base_path}/selector`,
    params,
  });
};

/**
 * 同步落地页列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullSiteListApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 批量创建落地页接口
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const batchCreateSiteApi = (data) => {
  return http.post({
    url: `${base_path}/batchCreate`,
    data,
  });
};
